import type { SuggestMonitorEntityOut } from '@repo/api-codegen';
import { Badge, Text } from '@repo/foundations';
import type { ExtendedDataTableColumn } from '../../../TableV2/types';
import { ParentRenderer, TitleRender } from './columnRenderers';

export const COLUMNS: ExtendedDataTableColumn<SuggestMonitorEntityOut>[] = [
	{
		accessor: 'title',
		titleLabel: 'Title',
		render: (record) => <TitleRender record={record} />,
		width: 200,
	},
	{
		accessor: 'parent',
		titleLabel: 'Parent',
		render: (record) => <ParentRenderer record={record} />,
		width: 160,
	},
	{
		accessor: 'created',
		titleLabel: 'Created',
		render: (record) =>
			record.monitor_created && (
				<Badge variant="success">
					<Text size="xs" color="text/secondary/default">
						Created
					</Text>
				</Badge>
			),
		width: 80,
	},
];
